import { Injectable } from '@angular/core';
import { DataService } from './../../../services/data.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, catchError} from 'rxjs';
import { AgencyMaster } from '../common-structure';

@Injectable()
export class AgencyDropdownService {
  private _url = 'agency/';
  constructor( private http_: HttpClient ) { }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  getAllAgency(): Observable<AgencyMaster[]> {
     return this.http_.get<AgencyMaster[]>(this._url, { headers: this.headers }).pipe(catchError(this.errorHandler));
   }

   errorHandler(error: HttpErrorResponse) {
    return throwError(() => new Error(error.message || 'server Error'));
  }
}
